import api from 'api'
import { documentTypes } from 'components/Users/I9DocumentUpload/constants'
import { isListComplete } from 'components/Users/I9DocumentUpload/utils'
import { z } from 'zod'

export const listDocumentSchema = z.object({
  listType: z.enum(['A', 'B', 'C', 'Supplementary']),
  frontImage: z.instanceof(File),
  backImage: z.instanceof(File).optional(),
  documentType: z.enum(documentTypes),
  documentNumber: z.string().optional(),
  expirationDate: z.string().optional(),
  issuingAuthority: z
    .string({ message: 'Issuing authority is required' })
    .optional(),
  dateOfBirth: z.string().optional(),
  name: z.string().optional(),
})

export type ListDocument = z.infer<typeof listDocumentSchema>

export const uploadI9DocumentRequest = z
  .object({
    documents: z.array(listDocumentSchema).min(1),
    isSupplementB: z.boolean().default(false),
  })
  .refine((data) => isListComplete(data.documents, data.isSupplementB), {
    message:
      'Must include either one List A document or a List B and List C combination',
  })

export type ListDocuments = z.infer<typeof uploadI9DocumentRequest>

export function uploadI9Document(userId: string, payload: ListDocuments) {
  const formData = new FormData()
  const { documents, isSupplementB } = uploadI9DocumentRequest.parse(payload)
  const data = documents.map(({ frontImage, backImage, ...document }) => {
    formData.append(`${document.documentType}_front_image`, frontImage)
    if (backImage) {
      formData.append(`${document.documentType}_back_image`, backImage)
    }
    return document
  })

  formData.append(
    'data',
    JSON.stringify({ documents: data, is_supplement_b: isSupplementB })
  )

  return api.post(`/admin/i9/user_documents/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
